import React from 'react'
import TableHeader from './table-header'
import TableData from './table-data'
import Loader from 'components/loader'

function Table({ headers = [], data = [], loading , keys = [] }) {
  return loading ? (
    <Loader />
  ) : (
    <div>
      <TableHeader headers={headers} />
      <TableData data={data} headers={headers} keys={keys} />
    </div>
  )
}

export default Table
